import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = null;

const fetchVaultRequest = (_, { payload }) => payload.request.params.id;

export default createReducer(initialState, {
  [actionTypes.FETCH_VAULT_REQUEST]: fetchVaultRequest,
});
